import curry from 'lodash/fp/curry';
import { ObservableMap } from 'mobx';
import { RootStore, RootStoreType } from '../RootStore';
import { getEnv, IStateTreeNode } from 'mobx-state-tree';
import { StoreEnvironment } from '../interfaces/StoreEnvironment';
import { ICellRendererParams } from 'ag-grid-community';
import moment from 'moment';
import config from '../../config';

export const mapStore = (func: (root: typeof RootStore.Type) => object) => (stores: { store: RootStoreType }) => {
  return func(stores.store);
};

export const createArrayFromMap = curry(<T>(mapData: ObservableMap, func: (t: T) => any): any[] => {
  const myArr: any[] = [];
  mapData.forEach((value) => {
    myArr.push(func(value));
  });
  return myArr;
});

export function getEnvironment(node: IStateTreeNode): StoreEnvironment {
  return getEnv(node) as StoreEnvironment;
}

export function renderGridDate(params: ICellRendererParams) {
  const { value } = params;
  return value && moment(value).isValid() ? formatDate(params.value) : '';
}

export function renderGridDateWithDay(params: ICellRendererParams) {
  const { value } = params;
  return value && moment(value).isValid() ? formatDateWithDay(params.value) : '';
}

export function formatDate(value: Date) {
  const format = config.dateFormat ? config.dateFormat : DateFormat;
  return moment(value).format(format);
}

export function formatDateWithDay(value: Date) {
  const format = config.dateFormatWithDay ? config.dateFormatWithDay : DateFormat;
  return moment(value).format(format);
}

export function renderGridDateTime(params: ICellRendererParams) {
  const { value } = params;
  return value && moment(value).isValid() ? formatDateTime(params.value) : '';
}

export function renderGridDateTimeWithDetails(params: ICellRendererParams) {
  const { value } = params;
  return value && moment(value).isValid() ? formatDateTimeWithDetails(params.value) : '';
}

export function formatDateTime(value: Date) {
  const format = config.dateTimeFormat ? config.dateTimeFormat : DateTimeFormat;
  return moment(value).format(format);
}

export function formatDateTimeWithDetails(value: Date) {
  const format = config.dateTimeFormatWithDetails ? config.dateTimeFormatWithDetails : DateTimeFormat;
  return moment(value).format(format);
}

export function formatDateWithSeconde(value: Date) {
  const format = DateTimeFormatSeconde;
  return moment(value).format(format);
}

export const DateFormat = 'DD/MM/YYYY';
export const DateWithDayStrFormat = 'ddd DD/MM/YYYY';
export const DateTimeFormat = 'DD/MM/YYYY HH:mm';
export const DateTimeFormatSeconde = 'DD/MM/YYYY HH:mm:ss';
export const DateWithDayAndMonthStrFormat = 'dddd DD MMMM YYYY';
export const DateFormatFormField = 'DD/MM/YYYY';

export const getUserLocation = (options?: PositionOptions) => {
  return new Promise((resolve: PositionCallback, reject: PositionErrorCallback) => {
    // throw "ERROR";
    navigator.geolocation.getCurrentPosition(resolve, reject, options);
  });
};

export function dateFilterWithSecond(comparaison: string, value: any, filterValue: any) {
  const formatedValue =
    value && moment(value.toUpperCase()).isValid() ? formatDateWithSeconde(value.toUpperCase()) : '';
  return dateFilter(comparaison, formatedValue, filterValue);
}

export function dateFilterNormal(comparaison: string, value: any, filterValue: string) {
  const formatedValue = value && moment(value.toUpperCase()).isValid() ? formatDate(value.toUpperCase()) : '';
  return dateFilter(comparaison, formatedValue, filterValue);
}

export function dateTimeFilterNormal(comparaison: string, value: any, filterValue: string) {
  const formatedValue = value && moment(value.toUpperCase()).isValid() ? formatDateTime(value.toUpperCase()) : '';
  return dateFilter(comparaison, formatedValue, filterValue);
}

export function dateFilter(comparaison: string, value: any, filterValue: string) {
  switch (comparaison) {
    case 'equals':
      return value === filterValue;
    case 'notEqual':
      return value !== filterValue;
    case 'startsWith':
      return value.startsWith(filterValue);
    case 'endsWith':
      return value.endsWith(filterValue);
    case 'contains':
      return value.indexOf(filterValue) >= 0;
    case 'notContains':
      return value.indexOf(filterValue) < 0;
    default:
      return false;
  }
}
